import { UseQueryOptions, useQuery } from 'react-query';
import { RobotDevice } from '../../types';
import { getRobotVolume } from '../api';
import { robotAudioKeys } from './keys';

export const useGetRobotVolume = (
  robot: RobotDevice | undefined,
  options?: UseQueryOptions<
    number,
    unknown,
    number,
    ReturnType<typeof robotAudioKeys.audio>
  >
) => {
  const robotId = robot?.id ?? '';

  const query = useQuery({
    queryKey: robotAudioKeys.audio(robotId),
    queryFn: () => getRobotVolume(robot?.websocketConnection?.ipAddress),
    enabled:
      robot?.id !== undefined &&
      robot?.websocketConnection?.ipAddress !== undefined,
    ...options,
  });

  return query;
};
